import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

import './App.css';
import DashboardLayout from './components/DashboardLayout';
import Login from './components/Login';

import { useSelector } from 'react-redux';



function App() {
  const isLoggedIn = useSelector(state => state.login.value);



  return (
    <div className="App">
      {isLoggedIn ? 
        <DashboardLayout /> :
        <Login />
      }

    </div>
  );
}

export default App;